import React, {useEffect} from "react";
import {connect, shallowEqual, useSelector} from "react-redux";
import { store, history } from 'bukku/redux/store';
import {getSidebarOptions} from "../../../containers/Sidebar/options";
import {Modal} from "antd";
import {t, Trans} from "@lingui/macro";
import {i18n} from "@lingui/core";
import {I18nProvider} from "@lingui/react";

function openLastVisitedPageModal(lastVisitedRoutes, subdomainLastVisitedRoute, subdomain, streams) {
    // Get descriptive path name --- eg: /sales/invoices => 'Sales Invoices'
    const flatSidebarOptions = getSidebarOptions(streams).map(o => (!o.children ? o : o.children)).flat();
    const routeDetail = flatSidebarOptions.find(o => o.key === subdomainLastVisitedRoute);

    Modal.confirm({
        title: t`Restore Last Visited Page?`,
        content: (
            <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                <Trans>
                    You were on&nbsp;
                    <strong>
                        {
                            routeDetail ?
                                t({id: routeDetail.label}) :
                                subdomainLastVisitedRoute
                        }
                        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                    </strong>&nbsp;last visit.
                </Trans>
                &nbsp;
                <Trans>
                    Would you like to continue where you left off?
                </Trans>
            </I18nProvider>
        ),
        maskClosable: true,
        onOk() {
            history.push(subdomainLastVisitedRoute);
        },
        onCancel() {
            // clear
            // eslint-disable-next-line no-param-reassign
            delete lastVisitedRoutes[subdomain];
            localStorage.setItem('last_visited_route', JSON.stringify(lastVisitedRoutes));
        },
        zIndex: 1000,
    });
    return false;
}

function saveLastVisit(location) {
    const { Auth } = store.getState();
    const { subdomain } = Auth;

    if (location.pathname !== '/signin') {
        const lastVisitedRoutesJSON = JSON.parse(localStorage.getItem('last_visited_route')) || {};
        lastVisitedRoutesJSON[subdomain] = location.pathname;
        localStorage.setItem('last_visited_route', JSON.stringify(lastVisitedRoutesJSON));
    }
}

function onSessionReady(streams) {
    const { Auth, App } = store.getState();
    const { subdomain, validateSessionState } = Auth;
    const { prevRoute } = App;
    const {location} = history;

    const lastVisitedRoutes = JSON.parse(localStorage.getItem('last_visited_route')) || null;
    const subdomainLastVisitedRoute = lastVisitedRoutes ? lastVisitedRoutes[subdomain] : null;

    if (
        prevRoute === '/signin'
        && validateSessionState === 'success' // prevent multiple prompts
        && subdomainLastVisitedRoute && subdomainLastVisitedRoute !== '/dashboard'
        && subdomainLastVisitedRoute !== '/' // don't prompt when last visited route that don't exist
        && subdomainLastVisitedRoute !== location.pathname // don't prompt when "go back"
        && history.length > 1 // don't prompt when "Open In New Tab"
    )
        openLastVisitedPageModal(lastVisitedRoutes, subdomainLastVisitedRoute, subdomain, streams);
}

/**
 * Main React Component
 */
function LastVisitedPageModal(props) {
    const { sessionReady } = props;
    // const streams = useSelector(state => state.Flow.streams, shallowEqual);
    const streamsList = useSelector(state => state.List.flowStreams, shallowEqual);

    useEffect(() => {
        // save the last visited route
        const unsubscribe = history.listen(saveLastVisit);
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        // When session is ready
        if (sessionReady)
            onSessionReady(streamsList);
    }, [sessionReady, streamsList]);

    return null;
}

export default connect(state => ({
    sessionReady: state.Auth.sessionReady,
}))(LastVisitedPageModal);
